import React, { useEffect, useState } from "react"
import { useFields } from "../App"

export default function StepThree() {
    const fields = useFields()
    const [errors, setErrors] = useState([])

    const canContinue =
        fields.form.firstName &&
        fields.form.lastName &&
        fields.form.email &&
        fields.form.phone &&
        errors.length === 0

    function isPhoneNumberCorrect() {
        const phoneExp = new RegExp(
            /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/
        )

        return phoneExp.test(fields.form.phone)
    }

    function isEmailCorrect() {
        const emailExp = new RegExp(
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        )

        return emailExp.test(fields.form.email)
    }

    useEffect(() => {
        let errors = []
        if (!isPhoneNumberCorrect()) {
            if (fields.form.phone && fields.form.phone.length > 8) {
                errors.push("Vul een correct telefoonnummer in.")
            }
        }

        if (!isEmailCorrect()) {
            if (fields.form.email && fields.form.email.length > 8) {
                errors.push("Vul een correct e-mailadres in.")
            }
        }

        setErrors(errors)
    }, [fields.form.phone, fields.form.email])

    return (
        <div className="sm:mt-10">
            <h3 className="mb-5 sm:text-2xl text-lg">Gegevens</h3>

            <form
                onSubmit={(e) => {
                    e.preventDefault()

                    if (canContinue) {
                        fields.setStep(4)
                    }
                }}
                className="sm:pr-10"
            >
                <div className="grid sm:grid-cols-2 gap-3 mb-3">
                    <input
                        type="text"
                        name="firstName"
                        placeholder="Voornaam"
                        required
                        onChange={(e) =>
                            fields.setFormField("firstName", e.target.value)
                        }
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Achternaam"
                        required
                        onChange={(e) =>
                            fields.setFormField("lastName", e.target.value)
                        }
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        required
                        onChange={(e) =>
                            fields.setFormField("email", e.target.value)
                        }
                    />
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Telefoonnummer"
                        required
                        onChange={(e) =>
                            fields.setFormField("phone", e.target.value)
                        }
                    />
                </div>

                <textarea
                    name="message"
                    className="w-full min-h-[150px] mb-3"
                    placeholder="Opmerking"
                    onChange={(e) =>
                        fields.setFormField("message", e.target.value)
                    }
                ></textarea>

                {/* <label className="flex items-center mb-10">
                    <input
                        type="checkbox"
                        name="voorwaarden"
                        className="mr-3"
                        required
                    />
                    <span>
                        Ik ga akkoord met de{" "}
                        <a href="/algemene-voorwaarden/">
                            Algemene Voorwaarden.
                        </a>
                    </span>
                </label> */}

                {errors.map((error) => (
                    <div key={error} className="text-[tomato] mb-2">
                        {error}
                    </div>
                ))}

                <div className="flex justify-end">
                    <button
                        className="button primary ml-auto"
                        disabled={!canContinue}
                        type="submit"
                    >
                        Versturen
                    </button>
                </div>
            </form>
        </div>
    )
}
